/** A horizontal Flexbox */

import { Box, styled } from '@mui/material'

export const HBox: typeof Box = styled('div')(({}) => ({
  display: 'flex',
  flexDirection: 'row',
})) as never
